import { createAction } from "@reduxjs/toolkit";

export const fetchConfig = createAction("FETCH_CONFIG@configuration");

export const fetchConfigSuccess = createAction("FETCH_CONFIG_SUCCESS@configuration");

export const geolocalizzaUtente = createAction("GEOLOCALIZZA_UTENTE@configuration");

export const setFromSaluteSimplex = createAction("SET_NAVIGATION_FROM_SALUTE_SIMPLEX@configuration");
